// extracted by mini-css-extract-plugin
module.exports = {"container":"CalendarBody--container--3sg1c","week":"CalendarBody--week--1JzAk"};